// extracted by mini-css-extract-plugin
export var description = "microInfoGraphic-module--description--51cbf";
export var microInfoGraphic = "microInfoGraphic-module--microInfoGraphic--72b52";
export var topBar = "microInfoGraphic-module--topBar--2376f";